export enum MessageStateTranslKey {
    CHANGE_TIME = "messageState:changeTime",
    CREATE_SINCE = "messageState:createUntil",
    CREATE_TO = "messageState:createTo",
    ERROR_CODE = "messageState:errorCode",
    ERROR_MESSAGE = "messageState:errorMessage",
    ID = "messageState:id",
    ISDS_STATE_OVERVIEW = "messageState:isdsMessageStateOverview",
    STATE = "messageState:state",
    STATUS_CODE = "messageState:statusCode",
}
